// extracted by mini-css-extract-plugin
module.exports = {"Testimonial":"Testimonial_Testimonial__10kSK","Name":"Testimonial_Name__2qiEo"};